module.exports = __webpack_public_path__ + "static/img/13areaA_2.5a5e5d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/13areaA_2.png
// module id = 1011
// module chunks = 1